// -----------------------------------------------------------------------------
// GLOBAL SITE CONFIG
// -----------------------------------------------------------------------------

let origin = window.location.origin;
let host = process.env.NODE_ENV == 'development'
    ? 'https://knapp-dev.jumptoday.group'
    : origin;

const siteConfig = {
    siteTitle: 'KNAPP',
    teachInURL: host + '/bl/storage/teachin/',
    api: host + '/bl/public/api',
    uploads: host + '/bl/public/uploads/',
    cdn: host + '/assets/',
    host: host
}

export {
    siteConfig
};
